<template>
  <div class="cashcreation">
    <div class="header-text"  :style="{ width: ElementHeight }">
      <h1 class="header-title">GIADA Friends券库管理-查看</h1>
      <div class="buttom-div">
        <el-button
          class="push-button"
          icon="iconfont icon-fanhui"
          @click="backHistory"
          >返回</el-button
        >
      </div>
    </div>
    <div class="header-text1"></div>
    <div class="biaoti">
      <span>基本信息</span>
    </div>
    <div>
      <el-card>
        <!-- 表单 -->
        <div>
          <el-form
            disabled
            :label-position="labelPosition"
            label-width="155px"
            size="small"
            class="form-div"
            ref="BasicInformation"
            :model="BasicData"
          >
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="券库编号">
                  <el-input readonly v-model="BasicData.coupGrpNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="状态">
                  <el-input readonly v-model="BasicData.state"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="券库名称">
                  <el-input readonly v-model="BasicData.couponsName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="券库后台名称">
                  <el-input
                    readonly
                    v-model="BasicData.innerCoupName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼券金额">
                  <el-input
                    readonly
                    type="Number"
                    v-model="BasicData.coupValue"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="使用的业务系统">
                  <el-checkbox-group
                    readonly
                    v-model="BasicData.systemBusinessSelect"
                  >
                    <el-checkbox
                      :label="item.appName"
                      :checked="item.optionSelect == 'true' ? true : false"
                      v-for="(item, index) in BasicData.systemBusiness"
                      :key="index"
                    ></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="券可用门店">
                  <el-radio-group readonly v-model="BasicData.isAllStore">
                    <el-radio label="全部门店"></el-radio>
                    <el-radio label="部分门店"></el-radio>
                  </el-radio-group>
                  <el-form-item>
                    <textarea
                      name=""
                      id=""
                      rows="8"
                      readonly
                      class="textareaClass textareaClass-store"
                      v-model="BasicData.listOfSomeStoreslStr"
                    ></textarea>
                  </el-form-item>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="使用需知">
                  <el-input
                    readonly
                    type="textarea"
                    class="textareaClass"
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    v-model="BasicData.usageNotice"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="是否进行商品折扣限制">
                  <el-checkbox-group
                    readonly
                    v-model="BasicData.isLimitGoodsDiscount"
                  >
                    <el-checkbox
                      :checked="BasicData.isLimitGoodsDiscount"
                      v-model="BasicData.isLimitGoodsDiscount"
                      name="type"
                    ></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="最高折扣">
                  <el-input
                    readonly
                    type="Number"
                    v-model="BasicData.maxDiscount"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼品不可转赠">
                  <el-checkbox-group readonly v-model="BasicData.ifGiving">
                    <el-checkbox
                      :checked="BasicData.ifGiving"
                      v-model="BasicData.ifGiving"
                      name="type"
                    ></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="最多使用张数">
                  <el-input
                    readonly
                    type="Number"
                    v-model="BasicData.useMaxQty"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="使用最低金额限制">
                  <el-input
                    readonly
                    type="Number"
                    v-model="BasicData.amountLimit"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="券有效期">
                  <el-radio-group
                    readonly
                    v-model="BasicData.SecuritiesExpirationTypeSelect"
                    class="periodOfValidity"
                  >
                    <el-form-item>
                      <el-radio :label="SecuritiesExpirationType[0].id"
                        >永不过期</el-radio
                      >
                    </el-form-item>
                    <el-form-item>
                      <el-radio :label="SecuritiesExpirationType[1].id">
                        <span style="font-size: 14px"
                          >有效期天数，从领券日期起</span
                        >
                        <el-input
                          type="text"
                          readonly
                          style="width: 90px"
                          v-model="BasicData.validDaySdata"
                        ></el-input>
                        <span style="font-size: 14px">天内有效</span>
                      </el-radio>
                    </el-form-item>
                    <el-form-item>
                      <el-radio :label="SecuritiesExpirationType[2].id">
                        <span style="font-size: 14px">有效期范围从</span>
                        <el-date-picker
                          readonly
                          v-model="BasicData.datePicker"
                          type="daterange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                        >
                        </el-date-picker>
                      </el-radio>
                    </el-form-item>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="券发送提醒">
                  <el-radio-group
                    readonly
                    v-model="BasicData.pubCoupProvideMode"
                  >
                    <el-radio
                      v-for="(item, index) in CouponreminderMethod"
                      :key="index"
                      :label="item.id"
                      >{{ item.detailText }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="券核销提醒">
                  <el-radio-group readonly v-model="BasicData.pubVeriCoupMode">
                    <el-radio
                      v-for="(item, index) in CouponreminderMethod"
                      :key="index"
                      :label="item.id"
                      >{{ item.detailText }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24" class="MaturityOfSecurities">
                <el-form-item label="券到期提醒">
                  <el-radio-group readonly v-model="BasicData.expirationMode">
                    <el-radio
                      v-for="(item, index) in CouponreminderMethod"
                      :key="index"
                      :label="item.id"
                      >{{ item.detailText }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item style="margin-left: -50px">
                  <span style="font-size: 14px">券到期前</span>
                  <el-input
                    style="width: 90px"
                    type="Number"
                    readonly
                    v-model="BasicData.expirationTime"
                  ></el-input>
                  <span style="font-size: 14px">天提醒</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <SelectProduct ref="Prod" :IsShow="true" :WhetherSee="true"></SelectProduct>
      </el-card>
    </div>
  </div>
</template>

<script>
import { couponsGroupDetail } from "@/api/couponsDepot.js";
import { mapState } from "vuex";
import SelectProduct from "/src/components/SelectProduct/index.vue";
export default {
  components: {
    SelectProduct: SelectProduct,
  },
  data() {
    return {
      screenWidth: "",
      ElementHeight: "0px",
      SecuritiesExpirationType: [
        {
          id: 1,
          detailText: "永不过期",
        },
        {
          id: 2,
          detailText: "从发卷开始固定日期",
        },
        {
          id: 3,
          detailText: "固定过期时间",
        },
      ],
      CouponreminderMethod: [
        {
          id: 0,
          detailText: "不提醒",
        },
        {
          id: 1,
          detailText: "公众号模板消息",
        },
        {
          id: 2,
          detailText: "短信消息",
        },
        {
          id: 3,
          detailText: "公众号模板消息和短信消息",
        },
      ],
      BasicData: {
        //基本信息
        couponsName: "", //券库名称
        innerCoupName: "", //券库后台名称
        coupValue: "", //礼券金额
        systemBusiness: [], //使用的业务系统
        systemBusinessSelect: [""], //选中业务系统
        isAllStore: "", //是否全门店可用
        listOfSomeStoresl: [], //选部分门店是选择的部分门店
        listOfSomeStoreslStr: "", //选部分门店是选择的部分门店组装数据
        usageNotice: "", //使用需知
        isLimitGoodsDiscount: false, //是否对商品的折扣进行限制
        maxDiscount: "", //最高折扣
        ifGiving: false, //礼品是否可以转送
        useMaxQty: "", //最多使用张数
        amountLimit: "", //使用最低金额限制
        SecuritiesExpirationTypeSelect: 2, //选择的劵有效期方式
        validDaySdata: "",
        datePicker: [],
        pubCoupProvideMode: 0, //券发放提醒方式
        expirationMode: 0, //到期提醒方式
        pubVeriCoupMode: 0, //券核销提醒方式
        expirationTime: 0, //到期提醒时间
      },
      labelPosition: "right",
    };
  },
  computed: {
    ...mapState({
      CouponsSelectChang: (state) => state.user.CouponsSelectChang,
    }),
  },
  mounted() {
    this.getELmentHeight(); //获取页面高度
  },
  watch:{
    //窗口宽度变化
    screenWidth(val) {
      this.ElementHeight =
        document.querySelector(".cashcreation").offsetWidth + "px";
    },
  },
  created() {
    this.RcouponsGroupDetail(); //卷库详情
  },
  methods: {
     getELmentHeight() {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    RcouponsGroupDetail() {
      let arr = ''
      if (this.$route.query.mm === undefined) {
        arr = this.CouponsSelectChang.couponsGrpID
      }else{
        arr = this.$route.query.mm
      }
      let data = require("qs").stringify({
        couponsGrpID: arr,
      });
      couponsGroupDetail(data).then((res) => {
        if (res.success) {
          let SecuritiesUsablegoods = {
            CommodityCategory: "所有商品",
            GoodsGenre: "",
            GenreType: "",
            GenreTypeRegion1: "",
            GenreTypeRegion2: "",
            GoodsType: "",
            GoodsTypeRegion1: "",
            GoodsTypeRegion2: "",
          };
          if (res.data.isAllProduct) {
            SecuritiesUsablegoods.CommodityCategory = "所有商品";
          } else {
            let NewSelectCategoryData = [], //选中的类别数据
              NewSelectCategoryLabelData = [], //选中的类别标签数据
              NewSelectGoodsData = [], //选中的商品数据
              NewSelectGoodsLableData = []; //选中的商品标签数据
            SecuritiesUsablegoods.CommodityCategory = "部分商品";
            if (res.data.productLimitKind == 1) {
              SecuritiesUsablegoods.GoodsGenre = "按类别";
              if (res.data.productMode == 1) {
                SecuritiesUsablegoods.GenreType = "按类别筛选";
                if (res.atrrValueList.length > 0) {
                  let SelectCategoryData = [];
                  res.atrrValueList.forEach((item) => {
                    item.categoryID = item.AtrrValue;
                    item.categoryCn = item.AtrrName;
                    SelectCategoryData.push(item);
                  });
                  NewSelectCategoryData = SelectCategoryData;
                }
                if (res.data.limitContainBD == 1) {
                  SecuritiesUsablegoods.GenreTypeRegion1 = "包含";
                } else {
                  SecuritiesUsablegoods.GenreTypeRegion1 = "排除";
                }
              } else if (res.data.productMode == 2) {
                SecuritiesUsablegoods.GenreType = "按类别标签筛选";
                if (res.lblList.length > 0) {
                  let SelectCategoryLabelData = [];
                  res.lblList.forEach((item) => {
                    item.lblName = item.LblName;
                    item.lblID = item.LblID;
                    SelectCategoryLabelData.push(item);
                  });
                  NewSelectCategoryLabelData = SelectCategoryLabelData;
                }
                if (res.data.limitContainBD == 1) {
                  SecuritiesUsablegoods.GenreTypeRegion2 = "包含";
                } else {
                  SecuritiesUsablegoods.GenreTypeRegion2 = "排除";
                }
              }
            } else if (res.data.productLimitKind == 2) {
              SecuritiesUsablegoods.GoodsGenre = "按商品";
              if (res.data.productMode == 1) {
                SecuritiesUsablegoods.GoodsType = "按商品筛选";
                if (res.atrrValueList.length > 0) {
                  let SelectGoodsData = [];
                  res.atrrValueList.forEach((item) => {
                    item.ProductName_CN = item.AtrrName;
                    SelectGoodsData.push(item);
                  });
                  NewSelectGoodsData = SelectGoodsData;
                }
                if (res.data.limitContainBD == 1) {
                  SecuritiesUsablegoods.GoodsTypeRegion1 = "包含";
                } else {
                  SecuritiesUsablegoods.GoodsTypeRegion1 = "排除";
                }
              } else if (res.data.productMode == 2) {
                SecuritiesUsablegoods.GoodsType = "按商品标签筛选";
                if (res.lblList.length > 0) {
                  let SelectGoodsLableData = [];
                  res.lblList.forEach((item) => {
                    item.lblID = item.LblID;
                    item.lblName = item.LblName;
                    SelectGoodsLableData.push(item);
                  });
                  NewSelectGoodsLableData = SelectGoodsLableData;
                }
                if (res.data.limitContainBD == 1) {
                  SecuritiesUsablegoods.GoodsTypeRegion2 = "包含";
                } else {
                  SecuritiesUsablegoods.GoodsTypeRegion2 = "排除";
                }
              }
            }
            this.$refs.Prod.SetdataPage(
              SecuritiesUsablegoods,
              NewSelectCategoryData,
              NewSelectCategoryLabelData,
              NewSelectGoodsData,
              NewSelectGoodsLableData
            );
          }
          if (res.data.isAllStore) {
            this.BasicData.isAllStore = "全部门店";
          } else {
            this.BasicData.isAllStore = "部分门店";
            if (res.shopList.length > 0) {
              this.BasicData.listOfSomeStoresl = res.shopList;
              this.BasicData.listOfSomeStoresl.forEach((item) => {
                this.BasicData.listOfSomeStoreslStr += `${item.ShopName}\n`;
              });
              // this.BasicData.listOfSomeStoreslStr =
              //   this.BasicData.listOfSomeStoreslStr.substring(
              //     0,
              //     this.BasicData.listOfSomeStoreslStr.length - 2
              //   );
            }
          }
          if (res.outApplications.length > 0) {
            //获取业务系统
            this.BasicData.systemBusiness = res.outApplications;
          }
          this.BasicData.coupValue = res.data.coupValue; //礼券金额
          this.BasicData.couponsName = res.data.couponsName; //礼券名称
          this.BasicData.coupGrpNo = res.data.coupGrpNo; //礼券编号
          this.BasicData.state =
            res.data.state == 0
              ? "启用"
              : res.data.state == 1
              ? "未启用"
              : res.data.state == 2
              ? "已禁用"
              : ""; //礼券状态
          this.BasicData.innerCoupName = res.data.innerCoupName; //礼券后台名称
          this.BasicData.usageNotice = res.data.usageNotice; //使用需知
          this.BasicData.isLimitGoodsDiscount = res.data.isLimitGoodsDiscount; //是否对商品的折扣进行限制
          this.BasicData.ifGiving = res.data.ifGiving; //礼品是否可以转送
          this.BasicData.maxDiscount = res.data.maxDiscount; //最高折扣
          this.BasicData.useMaxQty = res.data.useMaxQty; //最多使用张数
          this.BasicData.amountLimit = res.data.amountLimit; //使用最低金额限制
          this.BasicData.validDaySdata = res.data.validDay; //券有效日期
          let datePicker = [];
          datePicker[0] = this.renderTime(res.data.startDate); //开始日期
          datePicker[1] = this.renderTime(res.data.endDate); //结束日期
          this.BasicData.datePicker = datePicker;
          this.BasicData.expirationTime = res.data.expirationTime; //到期提醒时间
          this.BasicData.SecuritiesExpirationTypeSelect =
            res.data.timeLimitKind; //选择的劵有效期方式
          this.BasicData.pubCoupProvideMode = res.data.pubCoupProvideMode; //券发放提醒方式
          this.BasicData.expirationMode = res.data.expirationMode; //到期提醒方式
          this.BasicData.pubVeriCoupMode = res.data.pubVeriCoupMode; //券核销提醒方式
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    backHistory() {
      this.$router.go(-1); //返回上一层
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
.elUpload {
  box-sizing: border-box;
  border: none;
  display: flex;
  justify-content: center;
  width: 98px;
  height: 34px;
}
.buttom-flex {
  display: flex;
  flex-direction: row;
}
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.ConponesName:hover {
  cursor: pointer;
}
.margig-left80 {
  margin-left: 80px !important;
}
.formClass {
  margin-top: 10px;
}
.SelectArea {
  display: flex;
  margin-top: 8px;
  width: 140px;
}
.CategoryFiltering-div-top {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.CategoryFiltering-div {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 100%;
}
.CategoryFiltering-conter {
  // border: 1px solid #a8a8a8;
  display: flex;
  width: 1120px;
  height: 100%;
  margin-top: -15px;
}
.CategoryFiltering {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 700px;
  margin-top: 20px;
}
.right-top {
  display: flex;
  flex-direction: column;
  height: 430px;
}
.right-buttom {
  display: flex;
  flex-direction: column;
  height: 430px;
  margin-top: 20px;
}
.part-class-right {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.part-class-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  height: 470px;
}
.Coupons-part {
  display: flex;
  flex-direction: row;
  height: 100%;
  margin-left: 50px;
}
.Conpone-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  height: 50px;
}
.MaturityOfSecurities {
  display: flex;
}
.periodOfValidity {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.form-div {
  padding: 20px 0px;
  padding-left: 100px;
}
.textareaClass {
  resize: none;
  width: 100%;
}
.textareaClass-store {
  padding: 2px 10px;
}
.cashcreation {
  margin-bottom: 100px;
}
.push-button {
  width: 100px;
  background-color: #e9e7d3;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  height: 50px;
}
.header-title {
  min-width: 250px;
  line-height: 50px;
  height: 50px;
}
.header-text1 {
  height: 3.5rem;
}
.header-text {
  position: fixed;
  z-index: 88;
  margin-top: -1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: #f3f5f7;
  height: 4.5rem;
  color: #76734f;
  padding-bottom: 5px;
}
.biaoti {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  padding-left: 50px;
  background-color: #e3e3e3;
}
::v-deep {
  .el-card__body {
    padding: 20px 0 20px 0;
  }
  // 选择门店弹框样式
  .outlet {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 20px 10px 20px 10px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
}
</style>
